
import Vue from 'vue'
import VueRouter from 'vue-router'
import request from '../utils/request';


Vue.use(VueRouter)
//requireAuth: 是否需要检查登录
const routes = [
    //前台
  {
    path: '/',
    name: 'index',
    redirect: "/index",
    component: () => import('../views/front/main.vue'),
    meta: {title:'在线商城', path: '在线商城', requireAuth: false},
    children: [
	  {path: 'index', name: 'index', meta: {title:'首页',requireLogin: false}, component: () => import('../views/front/Index.vue'),},
      {path: 'build', name: 'build', meta: {title:'建设中',requireLogin: false}, component: () => import('../views/front/build/Index.vue'),},
      {path: 'buildd', name: 'buildd', meta: {title:'建设中',requireLogin: false}, component: () => import('../views/front/build/Indexd.vue'),},
      {path: 'goods', name: 'goods', meta: {title:'商品信息',requireLogin: false}, component: () => import('../views/front/goods/Index.vue'),},
      {path: 'goodsDetail', name: 'goodsDetail', meta: {title:'商品详情',requireLogin: false}, component: () => import('../views/front/goods/Detail.vue'),},
      {path: 'wsjj', name: 'wsjj', meta: {title:'网上竞价',requireLogin: false}, component: () => import('../views/front/wsjj/Index.vue'),},
      {path: 'ddfw', name: 'ddfw', meta: {title:'定点服务',requireLogin: false}, component: () => import('../views/front/ddfw/Index.vue'),},
      {path: 'cggg', name: 'cggg', meta: {title:'采购公告',requireLogin: false}, component: () => import('../views/front/cggg/Index.vue'),},
      {path: 'jggs', name: 'jggs', meta: {title:'结果公示',requireLogin: false}, component: () => import('../views/front/cggg/Jggs.vue'),},
	  {path: 'cggg/cgggDetail', name: 'cggg/cgggDetail', meta: {title:'详情',requireLogin: false}, component: () => import('../views/front/cggg/Detail.vue'),},
	  {path: 'cggg/cgggDetailorder', name: 'cggg/cgggDetailorder', meta: {title:'采购结果详情',requireLogin: false}, component: () => import('../views/front/cggg/Detailorder.vue'),},
	  {path: 'cggg/cgggQuote', name: 'cggg/cgggQuote', meta: {title:'采购报价',requireLogin: false}, component: () => import('../views/front/cggg/Quote.vue'),},
      {path: 'gysml', name: 'gysml', meta: {title:'供应商名录',requireLogin: false}, component: () => import('../views/front/gysml/Index.vue'),},
      {path: 'about', name: 'about', meta: {title:'关于平台',requireLogin: false}, component: () => import('../views/front/about/Index.vue'),},
      {path: 'notice', name: 'notice', meta: {title:'平台公告',requireLogin: false}, component: () => import('../views/front/about/Notice.vue'),},
    ]
  },
  //后台
  {
    path: '/manage',
    name: 'manage',
    component: () => import('../views/manage/Manage.vue'),
    redirect: "/manage/home",
    meta: {title:'后台', path: '后台',requireAuth: true},
    children: [
      {path: 'home', name: 'home', meta: {title:'主页', path: '主页',requireAuth: true}, component: () => import('../views/manage/Home.vue'),},
      // {path: 'user', name: 'user', meta: {title:'用户管理',path: '系统管理/用户管理',requireAuth: true}, component: () => import('../views/manage/User.vue'),},
      {path: 'person', name: 'person', meta: {title:'账户信息',path: '账户信息',requireAuth: true}, component: () => import('../views/Person.vue'),},
      {path: 'cgsorder', name: 'cgsorder', meta: {title:'订单管理',path: '订单管理',requireAuth: true}, component: () => import('../views/manage/cgs/Order.vue'),},
      {path: 'cgsorderdetail', name: 'cgsorderdetail', meta: {title:'订单详情',path: '订单详情',requireAuth: true}, component: () => import('../views/manage/cgs/OrderDetail.vue'),},
      {path: 'cgsdemand', name: 'cgsdemand', meta: {title:'需求管理',path: '需求管理',requireAuth: true}, component: () => import('../views/manage/cgs/Demand.vue'),},
      {path: 'cgsdemandadd', name: 'cgsdemandadd', meta: {title:'需求信息',path: '需求信息',requireAuth: true}, component: () => import('../views/manage/cgs/DemandAdd.vue'),},
      {path: 'cgsdemandquote', name: 'cgsdemandquote', meta: {title:'需求报价信息',path: '需求报价信息',requireAuth: true}, component: () => import('../views/manage/cgs/DemandQuote.vue'),},
      {path: 'gysgoods', name: 'gysgoods', meta: {title:'商品管理',path: '商品管理',requireAuth: true}, component: () => import('../views/manage/gys/Goods.vue'),},
      {path: 'gysgoodsadd', name: 'gysgoodsadd', meta: {title:'商品信息',path: '商品信息',requireAuth: true}, component: () => import('../views/manage/gys/GoodsAdd.vue'),},
      {path: 'gysorder', name: 'gysorder', meta: {title:'订单管理',path: '订单管理',requireAuth: true}, component: () => import('../views/manage/gys/Order.vue'),},
      {path: 'gysprice', name: 'gysprice', meta: {title:'报价管理',path: '报价管理',requireAuth: true}, component: () => import('../views/manage/gys/Price.vue'),},
	  {path: 'Pricedetail', name: 'Pricedetail', meta: {title:'报价详情',path: '报价详情',requireAuth: true}, component: () => import('../views/manage/gys/Pricedetail.vue'),}
  
    ]
  },
  
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
      requireAuth: false,
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: '注册',requireAuth: false,
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue')
  },
  {
    path: '/*',
    name: 'notFound',
    meta: {
      title: '找不到页面'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/404NotFound.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//beforeEach是router的钩子函数，在进入路由前执行
router.beforeEach((to, from, next) => {
  if(to.path == '/manage'){
    let user = localStorage.getItem("loginMsg");
    if(!user.accessToken){
      next('/login');
    }
  }
  let role;
  let allow = false;
  if(to.meta.requireAuth==true){
	  console.log('用户身份识别')
    //在后台获得该用户的身份
    // request.post("http://localhost:8888/role").then(res=>{
    //   if(res.code==='200'){
    //     role = res.data;
    //     console.log('您的身份是：'+role);
    //     if(role === 'admin'){
    //       allow = true;
    //     }
    //     else if(role==='user'){
    //         alert("您没有权限");
    //         allow = false;
    //         next("/")
    //     }
    //   }
    //   else{  //查询身份失败
    //     alert(res.msg);
    //     next('/login');
    //   }
    //   //放行
    //   if(allow === true){
    //     //设置网页title
    //     if (to.meta.title) {
    //       document.title = to.meta.title
    //     } else {
    //       document.title ='未知页面'
    //     }
    //     next()
    //   }
    // }
    // )
	if (to.meta.title) {
			if(localStorage.getItem("webMsg")){
				document.title = to.meta.title+'-'+JSON.parse(localStorage.getItem("webMsg")).websiteName+'-'+JSON.parse(localStorage.getItem("webMsg")).websiteInfo
			}else{
				document.title = to.meta.title
			}
	      
	    } else {
	      document.title ='未知页面'
	    }
	    next()
  }
  else{    //不需要判断权限
  console.log('用户身份无需识别')
    if(to.meta.requireLogin===true){
      if(!isLogin()){
        next('/login');
      }
    }
    if (to.meta.title) {
      if(localStorage.getItem("webMsg")){
      	document.title = to.meta.title+'-'+JSON.parse(localStorage.getItem("webMsg")).websiteName+'-'+JSON.parse(localStorage.getItem("webMsg")).websiteInfo
      }else{
      	document.title = to.meta.title
      }
    } else {
      document.title ='未知页面'
    }
    next()
  }

})

function isLogin() {
  let user = localStorage.getItem("loginMsg");
  if(user){
    return true;
  }else{
    return false;
  }
}
export default router
